import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Img from "gatsby-image"
import Layout from "../components/layout"
import styles from "../styles/international-conference-rates.module.scss"
import lithuania from "../images/delete/lithuania.svg"
import noneIcon from "../images/none-icon.svg"

export const query = graphql`
  query INTERNATONAL_ACCESS {
    wpgraphql {
      corePageBy(corePageId: 7474) {
        acfInternationalRates {
          legend
          title
          listGroup {
            colOneHeading
            colThreeHeading
            colTwoHeading
            row {
              included
              country
              localAccess
              tollFree
              flag {
                altText
                sourceUrl
                imageFile {
                  childImageSharp {
                    fixed(width: 26, webpQuality: 90) {
                      ...GatsbyImageSharpFixed_withWebp_noBase64
                    }
                  }
                }
              }
            }
          }
        }
        seo {
          metaDesc
          title
          twitterTitle
          twitterDescription
          opengraphTitle
          opengraphDescription
        }
      }
    }
  }
`

const InternationalConferenceRates = ({ data }) => {
  const listGroups = data.wpgraphql.corePageBy.acfInternationalRates.listGroup
  const seo = data.wpgraphql.corePageBy.seo

  return (
    <Layout bgColor="#f6f8fa">
      <SEO {...seo} />
      <div className={styles.wrapper}>
        <div className={styles.textContainer}>
          <h1>International Conference Rates</h1>
          <div className={styles.legend}>
            <span className={styles.asterisk} />
            Indicates that Local Access is included with Unlimited International
            plans
          </div>
        </div>
        <div className={styles.listsContainer}>
          {listGroups.map((group, index) => (
            <div key={index} className={styles.list}>
              {/* header */}
              <div className={styles.header}>
                <div className={styles.country}>{group.colOneHeading}</div>
                <div className={styles.localAccess}>{group.colTwoHeading}</div>
                <div className={styles.tollFree}>{group.colThreeHeading}</div>
              </div>
              {/* list */}

              {group.row.map((row, index) => (
                <div key={index} className={styles.row}>
                  <div className={styles.country}>
                    <span
                      className={`${styles.flag} ${
                        row.included ? styles.included : ""
                      }`}
                    >
                      <Img
                        fixed={row.flag.imageFile.childImageSharp.fixed}
                        alt={row.flag.altText}
                      />
                    </span>
                    {row.country}
                  </div>
                  <div className={styles.localAccess}>
                    {row.localAccess === "none" ? (
                      <img src={noneIcon} alt="none icon" />
                    ) : (
                      row.localAccess
                    )}
                  </div>
                  <div className={styles.tollFree}>
                    {row.tollFree === "none" ? (
                      <img src={noneIcon} alt="none icon" />
                    ) : (
                      row.tollFree
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default InternationalConferenceRates
